import api from "./api"; // axios instance

const API_URL = "/systemlog"; // ������� endpoint

/* ==========================
   FETCH SYSTEM LOGS
========================== */
export const fetchSystemLogs = async () => {
    try {
        const response = await api.get(API_URL);

        console.log("System logs fetched successfully:", response.data);

        return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
        if (error.response?.status === 404) {
            console.warn("No system logs found.");
            return [];
        }

        console.warn("Fetching system logs error:", error?.message);

        return [];
    }
};

export default {
    fetchSystemLogs,
};